import "./public.54dc7480.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire65f1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire65f1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lfY7d", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $f799a1554b37aa79$export$306c0aa65ff9ec16; }, function (v) { return $f799a1554b37aa79$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f799a1554b37aa79$export$306c0aa65ff9ec16;
"use strict";

var $iDFO9 = parcelRequire("iDFO9");
function $f799a1554b37aa79$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f799a1554b37aa79$var$objectIs = "function" === typeof Object.is ? Object.is : $f799a1554b37aa79$var$is, $f799a1554b37aa79$var$useState = $iDFO9.useState, $f799a1554b37aa79$var$useEffect = $iDFO9.useEffect, $f799a1554b37aa79$var$useLayoutEffect = $iDFO9.useLayoutEffect, $f799a1554b37aa79$var$useDebugValue = $iDFO9.useDebugValue;
function $f799a1554b37aa79$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $f799a1554b37aa79$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $f799a1554b37aa79$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $f799a1554b37aa79$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $f799a1554b37aa79$var$useEffect(function() {
        $f799a1554b37aa79$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $f799a1554b37aa79$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $f799a1554b37aa79$var$useDebugValue(value);
    return value;
}
function $f799a1554b37aa79$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f799a1554b37aa79$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f799a1554b37aa79$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $f799a1554b37aa79$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $f799a1554b37aa79$var$useSyncExternalStore$1 : $f799a1554b37aa79$var$useSyncExternalStore$2;
$f799a1554b37aa79$export$306c0aa65ff9ec16 = void 0 !== $iDFO9.useSyncExternalStore ? $iDFO9.useSyncExternalStore : $f799a1554b37aa79$var$shim;

});


var $jq7qJ = parcelRequire("jq7qJ");

var $MwOQn = parcelRequire("MwOQn");

var $iDFO9 = parcelRequire("iDFO9");

var $8ixLf = parcelRequire("8ixLf");

var $iDFO9 = parcelRequire("iDFO9");
var $f1f82361f9ceb31b$exports = {};
'use strict';

$f1f82361f9ceb31b$exports = (parcelRequire("lfY7d"));




// React.useInsertionEffect is not available in React <18
const { useEffect: $c3b8737e5f8c34e0$var$useEffect, useLayoutEffect: $c3b8737e5f8c34e0$var$useLayoutEffect, useRef: $c3b8737e5f8c34e0$var$useRef, useInsertionEffect: $c3b8737e5f8c34e0$var$useBuiltinInsertionEffect } = $iDFO9;
// Copied from:
// https://github.com/facebook/react/blob/main/packages/shared/ExecutionEnvironment.js
const $c3b8737e5f8c34e0$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $c3b8737e5f8c34e0$export$700979bc83e7db82 = $c3b8737e5f8c34e0$var$canUseDOM ? $c3b8737e5f8c34e0$var$useLayoutEffect : $c3b8737e5f8c34e0$var$useEffect;
const $c3b8737e5f8c34e0$export$aaabe4eda9ed9969 = $c3b8737e5f8c34e0$var$useBuiltinInsertionEffect || $c3b8737e5f8c34e0$export$700979bc83e7db82;
const $c3b8737e5f8c34e0$export$90fc3a17d93f704c = (fn)=>{
    const ref = $c3b8737e5f8c34e0$var$useRef([
        fn,
        (...args)=>ref[0](...args)
    ]).current;
    // Per Dan Abramov: useInsertionEffect executes marginally closer to the
    // correct timing for ref synchronization than useLayoutEffect on React 18.
    // See: https://github.com/facebook/react/pull/25881#issuecomment-1356244360
    $c3b8737e5f8c34e0$export$aaabe4eda9ed9969(()=>{
        ref[0] = fn;
    });
    return ref[1];
};


/*
 * Transforms `path` into its relative `base` version
 * If base isn't part of the path provided returns absolute path e.g. `~/app`
 */ const $2afa6485d8ff7df3$export$7413eea5ad243d4 = (base = "", path = location.pathname)=>!path.toLowerCase().indexOf(base.toLowerCase()) ? path.slice(base.length) || "/" : "~" + path;
const $2afa6485d8ff7df3$export$f1dd14e03b54dad4 = (to, base = "")=>to[0] === "~" ? to.slice(1) : base + to;


/**
 * History API docs @see https://developer.mozilla.org/en-US/docs/Web/API/History
 */ const $c35de50fdb844fad$var$eventPopstate = "popstate";
const $c35de50fdb844fad$var$eventPushState = "pushState";
const $c35de50fdb844fad$var$eventReplaceState = "replaceState";
const $c35de50fdb844fad$var$eventHashchange = "hashchange";
const $c35de50fdb844fad$export$4bf9923669ad6c63 = [
    $c35de50fdb844fad$var$eventPopstate,
    $c35de50fdb844fad$var$eventPushState,
    $c35de50fdb844fad$var$eventReplaceState,
    $c35de50fdb844fad$var$eventHashchange
];
const $c35de50fdb844fad$var$subscribeToLocationUpdates = (callback)=>{
    for (const event of $c35de50fdb844fad$export$4bf9923669ad6c63)addEventListener(event, callback);
    return ()=>{
        for (const event of $c35de50fdb844fad$export$4bf9923669ad6c63)removeEventListener(event, callback);
    };
};
const $c35de50fdb844fad$export$3a1ff78c39f8a86 = (fn, ssrFn)=>(0, $f1f82361f9ceb31b$exports.useSyncExternalStore)($c35de50fdb844fad$var$subscribeToLocationUpdates, fn, ssrFn);
const $c35de50fdb844fad$var$currentSearch = ()=>location.search;
const $c35de50fdb844fad$export$bd221a7c56b93941 = ()=>$c35de50fdb844fad$export$3a1ff78c39f8a86($c35de50fdb844fad$var$currentSearch);
const $c35de50fdb844fad$var$currentPathname = ()=>location.pathname;
const $c35de50fdb844fad$export$2a28ef6a9fe822a4 = ({ ssrPath: ssrPath } = {})=>$c35de50fdb844fad$export$3a1ff78c39f8a86($c35de50fdb844fad$var$currentPathname, ssrPath ? ()=>ssrPath : $c35de50fdb844fad$var$currentPathname);
const $c35de50fdb844fad$export$ff7962acd6052c28 = (to, { replace: replace = false } = {})=>history[replace ? $c35de50fdb844fad$var$eventReplaceState : $c35de50fdb844fad$var$eventPushState](null, "", to);
// the 2nd argument of the `useLocation` return value is a function
// that allows to perform a navigation.
//
// the function reference should stay the same between re-renders, so that
// it can be passed down as an element prop without any performance concerns.
// (This is achieved via `useEvent`.)
const $c35de50fdb844fad$var$useLocation = (opts = {})=>[
        (0, $2afa6485d8ff7df3$export$7413eea5ad243d4)(opts.base, $c35de50fdb844fad$export$2a28ef6a9fe822a4(opts)),
        (0, $c3b8737e5f8c34e0$export$90fc3a17d93f704c)((to, navOpts)=>$c35de50fdb844fad$export$ff7962acd6052c28((0, $2afa6485d8ff7df3$export$f1dd14e03b54dad4)(to, opts.base), navOpts))
    ];
var $c35de50fdb844fad$export$2e2bcd8739ae039 = $c35de50fdb844fad$var$useLocation;
// While History API does have `popstate` event, the only
// proper way to listen to changes via `push/replaceState`
// is to monkey-patch these methods.
//
// See https://stackoverflow.com/a/4585031
if (typeof history !== "undefined") for (const type of [
    $c35de50fdb844fad$var$eventPushState,
    $c35de50fdb844fad$var$eventReplaceState
]){
    const original = history[type];
    // TODO: we should be using unstable_batchedUpdates to avoid multiple re-renders,
    // however that will require an additional peer dependency on react-dom.
    // See: https://github.com/reactwg/react-18/discussions/86#discussioncomment-1567149
    history[type] = function() {
        const result = original.apply(this, arguments);
        const event = new Event(type);
        event.arguments = arguments;
        dispatchEvent(event);
        return result;
    };
}


// creates a matcher function
function $f2bce73903e546e7$export$2e2bcd8739ae039(makeRegexpFn = $f2bce73903e546e7$var$pathToRegexp) {
    let cache = {};
    // obtains a cached regexp version of the pattern
    const getRegexp = (pattern)=>cache[pattern] || (cache[pattern] = makeRegexpFn(pattern));
    return (pattern, path)=>{
        const { regexp: regexp, keys: keys } = getRegexp(pattern || "");
        const out = regexp.exec(path);
        if (!out) return [
            false,
            null
        ];
        // formats an object with matched params
        const params = keys.reduce((params, key, i)=>{
            params[key.name] = out[i + 1];
            return params;
        }, {});
        return [
            true,
            params
        ];
    };
}
// escapes a regexp string (borrowed from path-to-regexp sources)
// https://github.com/pillarjs/path-to-regexp/blob/v3.0.0/index.js#L202
const $f2bce73903e546e7$var$escapeRx = (str)=>str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
// returns a segment representation in RegExp based on flags
// adapted and simplified version from path-to-regexp sources
const $f2bce73903e546e7$var$rxForSegment = (repeat, optional, prefix)=>{
    let capture = repeat ? "((?:[^\\/]+?)(?:\\/(?:[^\\/]+?))*)" : "([^\\/]+?)";
    if (optional && prefix) capture = "(?:\\/" + capture + ")";
    return capture + (optional ? "?" : "");
};
const $f2bce73903e546e7$var$pathToRegexp = (pattern)=>{
    const groupRx = /:([A-Za-z0-9_]+)([?+*]?)/g;
    let match = null, lastIndex = 0, keys = [], result = "";
    while((match = groupRx.exec(pattern)) !== null){
        const [_, segment, mod] = match;
        // :foo  [1]      (  )
        // :foo? [0 - 1]  ( o)
        // :foo+ [1 - ∞]  (r )
        // :foo* [0 - ∞]  (ro)
        const repeat = mod === "+" || mod === "*";
        const optional = mod === "?" || mod === "*";
        const prefix = optional && pattern[match.index - 1] === "/" ? 1 : 0;
        const prev = pattern.substring(lastIndex, match.index - prefix);
        keys.push({
            name: segment
        });
        lastIndex = groupRx.lastIndex;
        result += $f2bce73903e546e7$var$escapeRx(prev) + $f2bce73903e546e7$var$rxForSegment(repeat, optional, prefix);
    }
    result += $f2bce73903e546e7$var$escapeRx(pattern.substring(lastIndex));
    return {
        keys: keys,
        regexp: new RegExp("^" + result + "(?:\\/)?$", "i")
    };
};



var $iDFO9 = parcelRequire("iDFO9");
/*
 * Router and router context. Router is a lightweight object that represents the current
 * routing options: how location is managed, base path etc.
 *
 * There is a default router present for most of the use cases, however it can be overridden
 * via the <Router /> component.
 */ const $9af1ac0ab256b57a$var$defaultRouter = {
    hook: (0, $c35de50fdb844fad$export$2e2bcd8739ae039),
    matcher: (0, $f2bce73903e546e7$export$2e2bcd8739ae039)(),
    base: ""
};
const $9af1ac0ab256b57a$var$RouterCtx = (0, $iDFO9.createContext)($9af1ac0ab256b57a$var$defaultRouter);
const $9af1ac0ab256b57a$export$9a302a45f65d0572 = ()=>(0, $iDFO9.useContext)($9af1ac0ab256b57a$var$RouterCtx);
/*
 * Part 1, Hooks API: useRoute, useLocation and useParams
 */ // Internal version of useLocation to avoid redundant useRouter calls
const $9af1ac0ab256b57a$var$useLocationFromRouter = (router)=>router.hook(router);
const $9af1ac0ab256b57a$export$45d76561a5302f2b = ()=>$9af1ac0ab256b57a$var$useLocationFromRouter($9af1ac0ab256b57a$export$9a302a45f65d0572());
const $9af1ac0ab256b57a$export$3f79f0b98112cf57 = (pattern)=>{
    const router = $9af1ac0ab256b57a$export$9a302a45f65d0572();
    const [path] = $9af1ac0ab256b57a$var$useLocationFromRouter(router);
    return router.matcher(pattern, path);
};
const $9af1ac0ab256b57a$var$ParamsCtx = (0, $iDFO9.createContext)({
    params: {}
});
const $9af1ac0ab256b57a$export$99eaa27ddbbb95ef = ()=>(0, $iDFO9.useContext)($9af1ac0ab256b57a$var$ParamsCtx).params;
const $9af1ac0ab256b57a$export$55185c17a0fcbe46 = ({ hook: hook, matcher: matcher, ssrPath: ssrPath, base: base = "", parent: parent, children: children })=>{
    // updates the current router with the props passed down to the component
    const updateRouter = (router, proto = parent || $9af1ac0ab256b57a$var$defaultRouter)=>{
        router.hook = hook || proto.hook;
        router.matcher = matcher || proto.matcher;
        router.ssrPath = ssrPath || proto.ssrPath;
        router.ownBase = base;
        // store reference to parent router
        router.parent = parent;
        return router;
    };
    // we use `useState` here, but it only catches the first render and never changes.
    // https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
    const [value] = (0, $iDFO9.useState)(()=>updateRouter({
            // We must store base as a property accessor because effects
            // somewhat counter-intuitively run in child components *first*!
            // This means that by the time a parent's base is updated in the
            // parent effect, the child effect has already run, and saw
            // the parent's *previous* base during its own execution.
            get base () {
                return (value.parent || $9af1ac0ab256b57a$var$defaultRouter).base + value.ownBase;
            }
        })); // create the object once...
    (0, $c3b8737e5f8c34e0$export$aaabe4eda9ed9969)(()=>{
        updateRouter(value);
    }); // ...then update it on each render
    return (0, $iDFO9.createElement)($9af1ac0ab256b57a$var$RouterCtx.Provider, {
        value: value,
        children: children
    });
};
// Helper to wrap children component inside the ParamsCtx provider
const $9af1ac0ab256b57a$var$ParamsWrapper = (params, children)=>(0, $iDFO9.createElement)($9af1ac0ab256b57a$var$ParamsCtx.Provider, {
        value: {
            params: params
        },
        children: children
    });
const $9af1ac0ab256b57a$export$e7b0ac011bb776c6 = ({ path: path, match: match, component: component, children: children })=>{
    const useRouteMatch = $9af1ac0ab256b57a$export$3f79f0b98112cf57(path);
    // `props.match` is present - Route is controlled by the Switch
    const [matches, params] = match || useRouteMatch;
    if (!matches) return null;
    // React-Router style `component` prop
    if (component) return $9af1ac0ab256b57a$var$ParamsWrapper(params, (0, $iDFO9.createElement)(component, {
        params: params
    }));
    // support render prop or plain children
    return $9af1ac0ab256b57a$var$ParamsWrapper(params, typeof children === "function" ? children(params) : children);
};
const $9af1ac0ab256b57a$export$a6c7ac8248d6e38a = (0, $iDFO9.forwardRef)((props, ref)=>{
    const router = $9af1ac0ab256b57a$export$9a302a45f65d0572();
    const [, navigate] = $9af1ac0ab256b57a$var$useLocationFromRouter(router);
    const { to: to, href: href = to, children: children, onClick: onClick } = props;
    const handleClick = (0, $c3b8737e5f8c34e0$export$90fc3a17d93f704c)((event)=>{
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
        onClick && onClick(event);
        if (!event.defaultPrevented) {
            event.preventDefault();
            navigate(to || href, props);
        }
    });
    // wraps children in `a` if needed
    const extraProps = {
        // handle nested routers and absolute paths
        href: href[0] === "~" ? href.slice(1) : router.base + href,
        onClick: handleClick,
        to: null,
        ref: ref
    };
    const jsx = (0, $iDFO9.isValidElement)(children) ? children : (0, $iDFO9.createElement)("a", props);
    return (0, $iDFO9.cloneElement)(jsx, extraProps);
});
const $9af1ac0ab256b57a$var$flattenChildren = (children)=>{
    return Array.isArray(children) ? [].concat(...children.map((c)=>c && c.type === (0, $iDFO9.Fragment) ? $9af1ac0ab256b57a$var$flattenChildren(c.props.children) : $9af1ac0ab256b57a$var$flattenChildren(c))) : [
        children
    ];
};
const $9af1ac0ab256b57a$export$b5d5cf8927ab7262 = ({ children: children, location: location })=>{
    const router = $9af1ac0ab256b57a$export$9a302a45f65d0572();
    const matcher = router.matcher;
    const [originalLocation] = $9af1ac0ab256b57a$var$useLocationFromRouter(router);
    for (const element of $9af1ac0ab256b57a$var$flattenChildren(children)){
        let match = 0;
        if ((0, $iDFO9.isValidElement)(element) && // we don't require an element to be of type Route,
        // but we do require it to contain a truthy `path` prop.
        // this allows to use different components that wrap Route
        // inside of a switch, for example <AnimatedRoute />.
        (match = element.props.path ? matcher(element.props.path, location || originalLocation) : [
            true,
            {}
        ])[0]) return (0, $iDFO9.cloneElement)(element, {
            match: match
        });
    }
    return null;
};
const $9af1ac0ab256b57a$export$2d8d895a0a0f636e = (props)=>{
    const { to: to, href: href = to } = props;
    const [, navigate] = $9af1ac0ab256b57a$export$45d76561a5302f2b();
    const redirect = (0, $c3b8737e5f8c34e0$export$90fc3a17d93f704c)(()=>navigate(to || href, props));
    // redirect is guaranteed to be stable since it is returned from useEvent
    (0, $c3b8737e5f8c34e0$export$700979bc83e7db82)(()=>{
        redirect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
};
var $9af1ac0ab256b57a$export$2e2bcd8739ae039 = $9af1ac0ab256b57a$export$3f79f0b98112cf57;


/* eslint-disable react/prop-types */ 
var $MwOQn = parcelRequire("MwOQn");

var $haVKD = parcelRequire("haVKD");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");

var $82ba4d6b84536c2f$export$4081345ed090ce95;
var $82ba4d6b84536c2f$export$bacb5cc5a11aef16;
var $82ba4d6b84536c2f$export$414d047e665c7112;
var $82ba4d6b84536c2f$export$666c3ad173ff70db;
var $82ba4d6b84536c2f$export$6bc7b24d4e862158;
var $82ba4d6b84536c2f$export$adb608be33961c98;
var $82ba4d6b84536c2f$export$38e42c68cf43b5d4;
var $82ba4d6b84536c2f$export$6bf99f0e53819a04;
var $82ba4d6b84536c2f$export$463d32b91de8b4d;
var $82ba4d6b84536c2f$export$f22da7240b7add18;
var $82ba4d6b84536c2f$export$d1bae722e5813031;
var $82ba4d6b84536c2f$export$cc74dcc53cfce4eb;
$82ba4d6b84536c2f$export$4081345ed090ce95 = `_8rrEiq_centered`;
$82ba4d6b84536c2f$export$bacb5cc5a11aef16 = `_8rrEiq_children`;
$82ba4d6b84536c2f$export$414d047e665c7112 = `_8rrEiq_contact`;
$82ba4d6b84536c2f$export$666c3ad173ff70db = `_8rrEiq_copyright`;
$82ba4d6b84536c2f$export$6bc7b24d4e862158 = `_8rrEiq_environment`;
$82ba4d6b84536c2f$export$adb608be33961c98 = `_8rrEiq_footer`;
$82ba4d6b84536c2f$export$38e42c68cf43b5d4 = `_8rrEiq_header`;
$82ba4d6b84536c2f$export$6bf99f0e53819a04 = `_8rrEiq_hideMobile`;
$82ba4d6b84536c2f$export$463d32b91de8b4d = `_8rrEiq_links`;
$82ba4d6b84536c2f$export$f22da7240b7add18 = `_8rrEiq_main`;
$82ba4d6b84536c2f$export$d1bae722e5813031 = `_8rrEiq_newsletter`;
$82ba4d6b84536c2f$export$cc74dcc53cfce4eb = `_8rrEiq_wrapper`;


const $4ee61bb427f29d8f$export$42a852a2b6b56249 = ({ children: children })=>{
    const [location, setLocation] = (0, $9af1ac0ab256b57a$export$45d76561a5302f2b)();
    const { value: { session: session } } = (0, $haVKD.useStore)();
    const richTemplate = !location.includes('/step');
    return /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $MwOQn.Fragment), {
        children: [
            richTemplate && /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                tag: "header",
                className: $82ba4d6b84536c2f$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                        row: true,
                        className: [
                            $82ba4d6b84536c2f$export$cc74dcc53cfce4eb,
                            $82ba4d6b84536c2f$export$6bc7b24d4e862158
                        ],
                        children: [
                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                small: true,
                                className: [
                                    $82ba4d6b84536c2f$export$414d047e665c7112,
                                    $82ba4d6b84536c2f$export$6bf99f0e53819a04
                                ],
                                children: "Contact us directly at +34 (0) 129 039 193"
                            }),
                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                                "data-mirai-component": "environment",
                                "data-locale": "true",
                                "data-currencies": "true",
                                "data-state": "true"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                        row: true,
                        className: [
                            $82ba4d6b84536c2f$export$cc74dcc53cfce4eb,
                            $82ba4d6b84536c2f$export$f22da7240b7add18
                        ],
                        children: [
                            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                row: true,
                                children: [
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        onPress: ()=>setLocation('/'),
                                        children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                            children: "Home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        className: $82ba4d6b84536c2f$export$6bf99f0e53819a04,
                                        onPress: ()=>setLocation('/about-us'),
                                        children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                            children: "About Us"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        className: $82ba4d6b84536c2f$export$6bf99f0e53819a04,
                                        onPress: ()=>setLocation('/rooms'),
                                        children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                            children: "Our Rooms"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                children: [
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        onPress: ()=>setLocation('/'),
                                        children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                            bold: true,
                                            brand: true,
                                            headline: true,
                                            level: 1,
                                            children: "Monalisa"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                        small: true,
                                        children: "HOTEL & RESORT"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                row: true,
                                children: [
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                                        "data-mirai-component": "session"
                                    }),
                                    !session && /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        className: $82ba4d6b84536c2f$export$6bf99f0e53819a04,
                                        onPress: ()=>setLocation('/signup'),
                                        children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                            medium: true,
                                            children: "Signup"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                tag: "main",
                className: $82ba4d6b84536c2f$export$bacb5cc5a11aef16,
                children: children
            }),
            richTemplate && /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                tag: "footer",
                className: $82ba4d6b84536c2f$export$adb608be33961c98,
                children: [
                    /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                        row: true,
                        className: [
                            $82ba4d6b84536c2f$export$cc74dcc53cfce4eb,
                            $82ba4d6b84536c2f$export$463d32b91de8b4d
                        ],
                        children: [
                            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                children: [
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                        bold: true,
                                        children: "Site map"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/'),
                                        children: "Home"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/signup'),
                                        children: "Signup"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/profile'),
                                        children: "Profile"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/deals'),
                                        children: "Deals"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/rooms'),
                                        children: "Rooms"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/finder'),
                                        children: "Finder"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                children: [
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                        bold: true,
                                        children: "Reservation"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/step1-rates'),
                                        children: "1. rates"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/step2-checkout'),
                                        children: "2. checkout"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/step3-booking'),
                                        children: "3. booking"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                children: [
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                        bold: true,
                                        children: "More"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                                        "data-mirai-component": "bookingQuery",
                                        "data-test-id": window.IS_PLAYWRIGHT ? 'bookingQuery' : undefined,
                                        children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                            inline: true,
                                            small: true,
                                            "data-ghost": true,
                                            children: "My Booking"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/legal-advice'),
                                        children: "Legal Advice"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/cookie-policy'),
                                        children: "Cookie Policy"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/privacy-policy'),
                                        children: "Privacy Policy"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Action), {
                                        inline: true,
                                        small: true,
                                        onPress: ()=>setLocation('/complaints-channel'),
                                        children: "Complaints Channel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                className: [
                                    $82ba4d6b84536c2f$export$d1bae722e5813031,
                                    $82ba4d6b84536c2f$export$6bf99f0e53819a04
                                ],
                                children: [
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                        bold: true,
                                        children: "Sign up for get our newsletter"
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Input), {
                                        name: "newsletter",
                                        placeholder: "Your email..."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.Text), {
                        small: true,
                        className: [
                            $82ba4d6b84536c2f$export$cc74dcc53cfce4eb,
                            $82ba4d6b84536c2f$export$666c3ad173ff70db
                        ],
                        children: [
                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                bold: true,
                                brand: true,
                                headline: true,
                                level: 2,
                                children: "Monalisa"
                            }),
                            ' ',
                            "\xa9 1980-2024 Monalisa Hotel Group Santa Engracia 120. 28003 Madrid, Spain"
                        ]
                    })
                ]
            })
        ]
    });
};



var $MwOQn = parcelRequire("MwOQn");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");
var $cd688b2d222a1c47$export$d6f8e41b69326771;
var $cd688b2d222a1c47$export$345c5736c8054f22;
var $cd688b2d222a1c47$export$586b24dc092f3131;
var $cd688b2d222a1c47$export$1edee58a52776cd9;
var $cd688b2d222a1c47$export$827f4ee28efc37;
var $cd688b2d222a1c47$export$aa3e815946b80764;
var $cd688b2d222a1c47$export$f9417f756858637d;
var $cd688b2d222a1c47$export$4081345ed090ce95;
var $cd688b2d222a1c47$export$4e0c71f277ca26b3;
var $cd688b2d222a1c47$export$a7db06668cad9adb;
var $cd688b2d222a1c47$export$ae58c3420da023e7;
var $cd688b2d222a1c47$export$d12a05a2da93ee73;
var $cd688b2d222a1c47$export$5c452ff88e35e47d;
var $cd688b2d222a1c47$export$6c9e2d66dea2a302;
var $cd688b2d222a1c47$export$9d5973a31741f172;
var $cd688b2d222a1c47$export$fe2e36411d703b3d;
var $cd688b2d222a1c47$export$f30f1338f6f15619;
var $cd688b2d222a1c47$export$560f31fcba5b1c20;
var $cd688b2d222a1c47$export$dd4f28cef696bc7d;
var $cd688b2d222a1c47$export$24ebf593b331c8aa;
var $cd688b2d222a1c47$export$6f093cfa640b7166;
var $cd688b2d222a1c47$export$29f9f81de5c56283;
var $cd688b2d222a1c47$export$cc74dcc53cfce4eb;
$cd688b2d222a1c47$export$d6f8e41b69326771 = `NBinRW_accent`;
$cd688b2d222a1c47$export$345c5736c8054f22 = `NBinRW_avatar`;
$cd688b2d222a1c47$export$586b24dc092f3131 = `NBinRW_backgroundImage`;
$cd688b2d222a1c47$export$1edee58a52776cd9 = `NBinRW_border`;
$cd688b2d222a1c47$export$827f4ee28efc37 = `NBinRW_box`;
$cd688b2d222a1c47$export$aa3e815946b80764 = `NBinRW_card`;
$cd688b2d222a1c47$export$f9417f756858637d = `NBinRW_cards`;
$cd688b2d222a1c47$export$4081345ed090ce95 = `NBinRW_centered`;
$cd688b2d222a1c47$export$4e0c71f277ca26b3 = `NBinRW_column`;
$cd688b2d222a1c47$export$a7db06668cad9adb = `NBinRW_content`;
$cd688b2d222a1c47$export$ae58c3420da023e7 = `NBinRW_finder`;
$cd688b2d222a1c47$export$d12a05a2da93ee73 = `NBinRW_home`;
$cd688b2d222a1c47$export$5c452ff88e35e47d = `NBinRW_image`;
$cd688b2d222a1c47$export$6c9e2d66dea2a302 = `NBinRW_pitch`;
$cd688b2d222a1c47$export$9d5973a31741f172 = `NBinRW_resident`;
$cd688b2d222a1c47$export$fe2e36411d703b3d = `NBinRW_section`;
$cd688b2d222a1c47$export$f30f1338f6f15619 = `NBinRW_slogan`;
$cd688b2d222a1c47$export$560f31fcba5b1c20 = `NBinRW_spaceBetween`;
$cd688b2d222a1c47$export$dd4f28cef696bc7d = `NBinRW_square`;
$cd688b2d222a1c47$export$24ebf593b331c8aa = `NBinRW_testimonials`;
$cd688b2d222a1c47$export$6f093cfa640b7166 = `NBinRW_text`;
$cd688b2d222a1c47$export$29f9f81de5c56283 = `NBinRW_texts`;
$cd688b2d222a1c47$export$cc74dcc53cfce4eb = `NBinRW_wrapper`;


const $ff7cdb36f4b3c638$export$6e8431c51fbb9069 = ()=>/*#__PURE__*/ (0, $MwOQn.jsxs)((0, $MwOQn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$827f4ee28efc37,
                    $cd688b2d222a1c47$export$d6f8e41b69326771
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                    className: $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                    children: [
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            bold: true,
                            headline: true,
                            level: 1,
                            children: "Deals"
                        }),
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            children: "Discover exclusive hotel offers tailored just for you."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                className: [
                    $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                    $cd688b2d222a1c47$export$827f4ee28efc37
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                    "data-mirai-component": "deals",
                    "data-id": new URLSearchParams(location.search).get('dealId') || '350807'
                })
            })
        ]
    });



var $MwOQn = parcelRequire("MwOQn");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");

const $3f8cbf50a0a5c5f0$export$18e31b43f608c6d2 = ()=>/*#__PURE__*/ (0, $MwOQn.jsxs)((0, $MwOQn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$827f4ee28efc37,
                    $cd688b2d222a1c47$export$d6f8e41b69326771
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                    className: ($cd688b2d222a1c47$export$cc74dcc53cfce4eb, $cd688b2d222a1c47$export$4081345ed090ce95),
                    children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                        bold: true,
                        headline: true,
                        level: 1,
                        children: "Finder"
                    })
                })
            }),
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                className: [
                    $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                    $cd688b2d222a1c47$export$827f4ee28efc37
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                    "data-mirai-component": "finder",
                    "data-layout": "column",
                    className: $cd688b2d222a1c47$export$4e0c71f277ca26b3
                })
            })
        ]
    });


/* eslint-disable react/no-unescaped-entities */ /* eslint-disable react/prop-types */ 
var $MwOQn = parcelRequire("MwOQn");

var $haVKD = parcelRequire("haVKD");

var $lKYwR = parcelRequire("lKYwR");

var $iDFO9 = parcelRequire("iDFO9");
const $0bae713585d4e871$export$1936e5489ad671bc = [
    {
        text: 'My stay at Monalisa was spectacular. From the moment I entered, I was struck by the elegance and welcoming atmosphere. The staff was always friendly and helpful, making our visit even more special. We will definitely be back soon.',
        rating: 5,
        name: 'Hal Finney',
        jobPosition: 'Marketing Manager'
    },
    {
        text: 'The Monalisa Resort is simply incredible. The facilities are top-notch, and the views from my room were breathtaking. The customer service exceeded all my expectations. A perfect place to relax and unwind.',
        rating: 5,
        name: 'Gavin Andresen',
        jobPosition: 'Financial Consultant'
    },
    {
        text: 'I have never experienced such a level of luxury and comfort as at Monalisa. The attention to detail in every corner of the hotel was astonishing. The restaurant offered an exquisite variety of dishes, all delicious. Highly recommended!',
        rating: 5,
        name: 'Martti Malmi',
        jobPosition: 'Real Estate Agent'
    },
    {
        text: "I had a wonderful weekend at the Monalisa Resort. The location is perfect, and the quality of service is unmatched. The spa was a rejuvenating experience that left me completely relaxed. I can\u2019t wait to return!",
        rating: 4,
        name: 'Jeff Garzik',
        jobPosition: 'Event Planner'
    },
    {
        text: 'From the moment we arrived, we were treated like royalty. The staff is exceptionally attentive and kind. The rooms are spacious and comfortable, and the decor is modern and sophisticated. An unforgettable experience.',
        rating: 5,
        name: 'Laszlo Hanyecz',
        jobPosition: 'Software Engineer'
    },
    {
        text: 'Monalisa - Hotel & Resort is a true paradise. The leisure areas and the surrounding landscape create a serene and peaceful environment. The breakfast buffet had a great variety and everything was delicious. We will definitely be back.',
        rating: 4,
        name: 'Nick Szabo',
        jobPosition: 'Architect'
    },
    {
        text: 'This is the best hotel I have ever stayed in. Everything, from check-in to check-out, was impeccable. The gardens are beautiful and the staff always made sure we had everything we needed. Highly recommended.',
        rating: 5,
        name: 'Adam Back',
        jobPosition: 'Business Consultant'
    },
    {
        text: 'Monalisa offers a perfect combination of luxury and comfort. The views from the pool are stunning, and the quality of service is outstanding. An ideal place for a family vacation or a romantic getaway.',
        rating: 5,
        name: 'Charlie Lee',
        jobPosition: 'Graphic Designer'
    }
];



const $062d3cd584bf3ac7$var$EVENT_INTENT_ENVIRONMENT = 'intentEnvironment';
const $062d3cd584bf3ac7$export$b94310965bed44e6 = ()=>{
    const { isMobile: isMobile } = (0, $lKYwR.useDevice)();
    const [locale, setLocale] = (0, $iDFO9.useState)();
    const [resident, setResident] = (0, $iDFO9.useState)();
    (0, $iDFO9.useEffect)(()=>{
        const handleIntentEnvironment = ({ locale: value } = {})=>setLocale(value);
        (0, $haVKD.Event).subscribe($062d3cd584bf3ac7$var$EVENT_INTENT_ENVIRONMENT, handleIntentEnvironment);
        return ()=>(0, $haVKD.Event).unsubscribe($062d3cd584bf3ac7$var$EVENT_INTENT_ENVIRONMENT, handleIntentEnvironment);
    }, []);
    (0, $iDFO9.useEffect)(()=>{
        (0, $haVKD.Event).publish('setStore', {
            promocode: resident ? 'RESIDENT' : ''
        });
    }, [
        resident
    ]);
    const showResident = locale === 'es-ES';
    const testId = window.IS_PLAYWRIGHT ? 'finder' : undefined;
    return /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $MwOQn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$a7db06668cad9adb,
                    $cd688b2d222a1c47$export$d12a05a2da93ee73
                ],
                children: [
                    /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                        className: [
                            $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                            $cd688b2d222a1c47$export$4081345ed090ce95
                        ],
                        children: [
                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                bold: true,
                                brand: true,
                                className: [
                                    $cd688b2d222a1c47$export$f30f1338f6f15619,
                                    $cd688b2d222a1c47$export$6f093cfa640b7166
                                ],
                                children: "Discover the Serenity of a Perfect Stay"
                            }),
                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                className: [
                                    $cd688b2d222a1c47$export$6c9e2d66dea2a302,
                                    $cd688b2d222a1c47$export$6f093cfa640b7166
                                ],
                                children: "Experience the calming atmosphere of our serene guest rooms, each designed with your comfort in mind."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                        className: $cd688b2d222a1c47$export$586b24dc092f3131
                    })
                ]
            }),
            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                className: [
                    $cd688b2d222a1c47$export$ae58c3420da023e7,
                    $cd688b2d222a1c47$export$4081345ed090ce95,
                    showResident && $cd688b2d222a1c47$export$9d5973a31741f172
                ],
                children: [
                    showResident && /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                        children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.InputOption), {
                            checked: resident,
                            name: "resident",
                            label: "I am resident",
                            onChange: setResident,
                            className: $cd688b2d222a1c47$export$9d5973a31741f172
                        })
                    }),
                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                        "data-mirai-component": "finder",
                        "data-test-id": testId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                row: !isMobile,
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$560f31fcba5b1c20,
                    $cd688b2d222a1c47$export$cc74dcc53cfce4eb
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                    className: $cd688b2d222a1c47$export$29f9f81de5c56283,
                    children: [
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            brand: true,
                            headline: true,
                            level: 1,
                            children: "Welcome to Monalisa"
                        }),
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            lighten: true,
                            children: "Welcome to Monalisa, where Monalisa and convenience converge in the heart of the city. Our hotel is located in the bustling city center, just steps away from the best shopping, dining, and entertainment that the city has to offer."
                        }),
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            lighten: true,
                            children: "One of our greatest strengths is our location. We are situated in the middle of the city center, which means that our guests can easily explore all the sights and sounds of this vibrant metropolis. Plus, we are just a stone's throw away from the train station, making it incredibly easy for our guests to arrive and depart from our hotel."
                        }),
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            lighten: true,
                            children: "So why wait? Book your stay at Monalisa today and experience the perfect blend of Monalisa, convenience, and comfort in the heart of the city."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                row: !isMobile,
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$d6f8e41b69326771,
                    $cd688b2d222a1c47$export$24ebf593b331c8aa
                ],
                children: [
                    /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                        children: [
                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                brand: true,
                                headline: true,
                                level: 1,
                                children: "Testimonials"
                            }),
                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                children: "See what our guests are saying about their serene and tranquil experiences at Monalisa."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.ScrollView), {
                        horizontal: true,
                        snap: !isMobile,
                        className: $cd688b2d222a1c47$export$f9417f756858637d,
                        children: (0, $0bae713585d4e871$export$1936e5489ad671bc).map(({ text: text, rating: rating, name: name, jobPosition: jobPosition } = {}, index)=>/*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                className: $cd688b2d222a1c47$export$aa3e815946b80764,
                                children: [
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                        action: true,
                                        children: text
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                        accent: true,
                                        action: true,
                                        children: "\u2605".repeat(rating)
                                    }),
                                    /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                        row: true,
                                        children: [
                                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                                                className: $cd688b2d222a1c47$export$345c5736c8054f22,
                                                style: {
                                                    backgroundImage: `url(https://i.pravatar.cc/96?u=${index})`
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                                                children: [
                                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                                        action: true,
                                                        children: name
                                                    }),
                                                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                                        lighten: true,
                                                        small: true,
                                                        children: jobPosition
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            !window.IS_PLAYWRIGHT && /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                row: !isMobile,
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$cc74dcc53cfce4eb
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                    "data-mirai-component": "finder",
                    "data-layout": "expand"
                })
            }),
            /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                row: true,
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$1edee58a52776cd9,
                    $cd688b2d222a1c47$export$4081345ed090ce95
                ],
                children: [
                    /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                        children: [
                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                children: "FIND BEST HOTEL FOR LEAVING"
                            }),
                            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                                bold: true,
                                brand: true,
                                headline: true,
                                level: 1,
                                children: "Find the Best Hotel in Your Next Vacation"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                        "data-mirai-component": "buttonFinder"
                    })
                ]
            })
        ]
    });
};



var $MwOQn = parcelRequire("MwOQn");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");


const $76d159350e1a14cf$export$271f9f08425019c7 = ()=>{
    const [, setLocation] = (0, $9af1ac0ab256b57a$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
        tag: "section",
        className: [
            $cd688b2d222a1c47$export$fe2e36411d703b3d,
            $cd688b2d222a1c47$export$1edee58a52776cd9,
            $cd688b2d222a1c47$export$d12a05a2da93ee73
        ],
        children: /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
            className: [
                $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                $cd688b2d222a1c47$export$4081345ed090ce95
            ],
            children: [
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                    bold: true,
                    className: $cd688b2d222a1c47$export$f30f1338f6f15619,
                    children: "Oops! Something went wrong."
                }),
                /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.Text), {
                    headline: true,
                    children: [
                        "Url ",
                        window.location.href,
                        " is not a valid."
                    ]
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Button), {
                    preventDefault: false,
                    onPress: ()=>setLocation('/'),
                    children: "RETURN TO HOME \u2192"
                })
            ]
        })
    });
};



var $MwOQn = parcelRequire("MwOQn");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");

const $d5c04257c22867e6$export$5120f2d0b8d4cab8 = ()=>/*#__PURE__*/ (0, $MwOQn.jsxs)((0, $MwOQn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$827f4ee28efc37,
                    $cd688b2d222a1c47$export$d6f8e41b69326771
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                    className: $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                    children: [
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            bold: true,
                            brand: true,
                            headline: true,
                            level: 1,
                            children: "Your profile"
                        }),
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            children: "Explore and manage your personal profile settings here."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                className: [
                    $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                    $cd688b2d222a1c47$export$827f4ee28efc37
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                    "data-mirai-component": "profile"
                })
            })
        ]
    });



var $MwOQn = parcelRequire("MwOQn");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");

const $7d94a9f0ea16dd1d$export$eaa9a96296f87c60 = ()=>/*#__PURE__*/ (0, $MwOQn.jsxs)((0, $MwOQn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$827f4ee28efc37,
                    $cd688b2d222a1c47$export$d6f8e41b69326771
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                    className: $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                    children: [
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            bold: true,
                            headline: true,
                            level: 1,
                            children: "Rooms"
                        }),
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            children: "Book this room now!"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                className: [
                    $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                    $cd688b2d222a1c47$export$827f4ee28efc37
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                    "data-mirai-component": "rooms",
                    "data-id": new URLSearchParams(location.search).get('roomId') || '63971'
                })
            })
        ]
    });



var $MwOQn = parcelRequire("MwOQn");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");
const $59be92bd6100ba78$export$317e7082611cb548 = ()=>/*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
        "data-mirai-component": "rates",
        "data-test-id": window.IS_PLAYWRIGHT ? 'rates' : undefined
    });



var $MwOQn = parcelRequire("MwOQn");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");
const $fc22e74f8ddc9e6c$export$7228562781001272 = ()=>/*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
        "data-mirai-component": "checkout",
        "data-session": "true"
    });



var $MwOQn = parcelRequire("MwOQn");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");
const $b5bba9407cef3d94$export$d8ccc25b3be9c9d7 = ()=>/*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
        "data-mirai-component": "booking"
    });



var $MwOQn = parcelRequire("MwOQn");

var $lKYwR = parcelRequire("lKYwR");
parcelRequire("iDFO9");

const $fa517188d29461c2$export$89200835fb4edfb9 = ()=>/*#__PURE__*/ (0, $MwOQn.jsxs)((0, $MwOQn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                tag: "section",
                className: [
                    $cd688b2d222a1c47$export$fe2e36411d703b3d,
                    $cd688b2d222a1c47$export$827f4ee28efc37,
                    $cd688b2d222a1c47$export$d6f8e41b69326771
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $lKYwR.View), {
                    className: $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                    children: [
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            bold: true,
                            brand: true,
                            headline: true,
                            level: 1,
                            children: "Signup"
                        }),
                        /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.Text), {
                            children: "Join Club Monalisa for free and enjoy exclusive benefits"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                className: [
                    $cd688b2d222a1c47$export$cc74dcc53cfce4eb,
                    $cd688b2d222a1c47$export$827f4ee28efc37
                ],
                children: /*#__PURE__*/ (0, $MwOQn.jsx)((0, $lKYwR.View), {
                    "data-mirai-component": "signup"
                })
            })
        ]
    });




const $9fa4c673139a6920$var$App = ()=>{
    const [location] = (0, $9af1ac0ab256b57a$export$45d76561a5302f2b)();
    (0, $iDFO9.useEffect)(()=>{
        const pageShowCallback = (event)=>event.persisted && window.Mirai.core(true);
        const interval = setInterval(async ()=>{
            if (window.Mirai.core) {
                clearInterval(interval);
                await window.Mirai.core();
                const { components: components = [], ready: ready } = window.Mirai;
                if (ready && components.filter(({ component: component } = {})=>[
                        'booking',
                        'checkout',
                        'rates'
                    ].includes(component).length > 0)) window.addEventListener('pageshow', pageShowCallback);
            }
        }, 100);
        window.scrollTo({
            behavior: 'smooth',
            top: 0
        });
        return ()=>{
            clearInterval(interval);
            window.removeEventListener('pageshow', pageShowCallback);
        };
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $MwOQn.jsx)((0, $4ee61bb427f29d8f$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $MwOQn.jsxs)((0, $9af1ac0ab256b57a$export$b5d5cf8927ab7262), {
            children: [
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/',
                    component: (0, $062d3cd584bf3ac7$export$b94310965bed44e6)
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/signup',
                    component: (0, $fa517188d29461c2$export$89200835fb4edfb9)
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/profile',
                    component: (0, $d5c04257c22867e6$export$5120f2d0b8d4cab8)
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/deals',
                    component: (0, $ff7cdb36f4b3c638$export$6e8431c51fbb9069)
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/rooms',
                    component: (0, $7d94a9f0ea16dd1d$export$eaa9a96296f87c60)
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/finder',
                    component: (0, $3f8cbf50a0a5c5f0$export$18e31b43f608c6d2)
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/step0-accommodations',
                    component: undefined
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/step1-rates',
                    component: (0, $59be92bd6100ba78$export$317e7082611cb548)
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/step2-checkout',
                    component: (0, $fc22e74f8ddc9e6c$export$7228562781001272)
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: '/step3-booking',
                    component: (0, $b5bba9407cef3d94$export$d8ccc25b3be9c9d7)
                }),
                /*#__PURE__*/ (0, $MwOQn.jsx)((0, $9af1ac0ab256b57a$export$e7b0ac011bb776c6), {
                    path: "/:location*",
                    children: (params)=>/*#__PURE__*/ (0, $MwOQn.jsx)((0, $76d159350e1a14cf$export$271f9f08425019c7), (0, $jq7qJ._)({}, params))
                })
            ]
        })
    });
};
(0, $8ixLf.createRoot)(document.getElementById('app')).render(/*#__PURE__*/ (0, $MwOQn.jsx)($9fa4c673139a6920$var$App, {}));


//# sourceMappingURL=public.c9158f83.js.map
